function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.14,
    height: 14.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9413333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 7.06,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.12,
    width: 23.14,
    height: 14.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8238888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 21.535,
    fontFamily: "Arial"
  }, "\n        Manassas_Park_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.96,
    width: 23.14,
    height: 17.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6218181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 37.88,
    fontFamily: "Arial"
  }, "\n        Norton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.79,
    width: 23.14,
    height: 20.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 57.19,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 67.59,
    width: 23.14,
    height: 23.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2855555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 79.4,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.21,
    width: 23.14,
    height: 23.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 103.02499999999999,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.83,
    width: 23.14,
    height: 24.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1036363636363635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 126.88,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.94,
    width: 23.14,
    height: 24.34,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2178947368421054
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 151.10999999999999,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 163.28,
    width: 23.14,
    height: 24.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2178947368421054
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 175.635,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.99,
    width: 23.14,
    height: 24.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.101904761904762
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 200.41500000000002,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.84,
    width: 23.14,
    height: 25.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 225.42000000000002,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 238,
    width: 23.14,
    height: 25.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 250.6,
    fontFamily: "Arial"
  }, "\n        Emporia_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.2,
    width: 23.14,
    height: 25.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6528571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 275.895,
    fontFamily: "Arial"
  }, "\n        Lexington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 288.59,
    width: 23.14,
    height: 26.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 301.875,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 315.16,
    width: 23.14,
    height: 28.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5426666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 329.43,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 343.71,
    width: 23.14,
    height: 28.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 357.995,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 372.27,
    width: 23.14,
    height: 28.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 386.58,
    fontFamily: "Arial"
  }, "\n        Bedford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 400.89,
    width: 23.14,
    height: 29.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 415.675,
    fontFamily: "Arial"
  }, "\n        Galax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 430.46,
    width: 23.14,
    height: 30.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3611764705882354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 445.66499999999996,
    fontFamily: "Arial"
  }, "\n        South_Boston_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 460.87,
    width: 23.14,
    height: 32.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 477.335,
    fontFamily: "Arial"
  }, "\n        Poquoson_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.81,
    width: 23.14,
    height: 32.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5426666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 510.3,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 526.79,
    width: 23.14,
    height: 34.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 543.8199999999999,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.85,
    width: 23.14,
    height: 34.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3611764705882354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 578.0450000000001,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 595.25,
    width: 23.14,
    height: 34.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5426666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 612.53,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 629.8,
    width: 23.14,
    height: 34.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 647.2299999999999,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 664.66,
    width: 23.14,
    height: 35.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.57,
    y: 682.3299999999999,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 0,
    width: 26.2,
    height: 32.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.24,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.34,
    y: 0,
    width: 26.91,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.681875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.795,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 0,
    width: 27.95,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4710526315789474
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.235,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 0,
    width: 28.03,
    height: 32.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0021428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.225,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Covington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.24,
    y: 0,
    width: 28.3,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6647058823529413
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.39000000000001,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.53,
    y: 0,
    width: 28.59,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0421428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.825,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.12,
    y: 0,
    width: 29.25,
    height: 32.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0892857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.745,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.37,
    y: 0,
    width: 30.62,
    height: 32.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3553846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.68,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 0,
    width: 32.2,
    height: 32.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.1,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.2,
    y: 0,
    width: 32.29,
    height: 32.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7938888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.34499999999997,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.49,
    y: 0,
    width: 32.34,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.02125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.66,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.83,
    y: 0,
    width: 33.1,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5076923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.38,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Manassas_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.93,
    y: 0,
    width: 33.28,
    height: 32.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9176470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.57,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.21,
    y: 0,
    width: 34.21,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9176470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.315,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.42,
    y: 0,
    width: 34.76,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.8,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.18,
    y: 0,
    width: 35.66,
    height: 32.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5076923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.01,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.84,
    y: 0,
    width: 36.08,
    height: 32.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.88,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.92,
    y: 0,
    width: 36.26,
    height: 32.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5076923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.05,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.18,
    y: 0,
    width: 36.51,
    height: 32.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.435,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.69,
    y: 0,
    width: 36.54,
    height: 32.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5523809523809524
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.96,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 662.23,
    y: 0,
    width: 37.77,
    height: 32.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.115,
    y: 16.3,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 32.6,
    width: 37.13,
    height: 34.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.135625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 49.685,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 66.77,
    width: 37.13,
    height: 34.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 84.09,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 101.41,
    width: 37.13,
    height: 35.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8694736842105264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 119.17,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 136.94,
    width: 37.13,
    height: 35.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0988235294117645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 154.78,
    fontFamily: "Arial"
  }, "\n        Falls_Church_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 172.61,
    width: 37.13,
    height: 36.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0455555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 191.02,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 209.43,
    width: 37.13,
    height: 37.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 228.07500000000002,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 246.73,
    width: 37.13,
    height: 38.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1841176470588235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 265.935,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 285.14,
    width: 37.13,
    height: 38.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 304.425,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 323.71,
    width: 37.13,
    height: 39.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8561538461538465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 343.67499999999995,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 363.65,
    width: 37.13,
    height: 40.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9542105263157896
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 383.67499999999995,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 403.69,
    width: 37.13,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8561538461538465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 423.755,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 443.83,
    width: 37.13,
    height: 40.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 464.135,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 484.43,
    width: 37.13,
    height: 41.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1841176470588235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 505.265,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 526.1,
    width: 37.13,
    height: 41.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.652142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 547.005,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 567.91,
    width: 37.13,
    height: 42.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 589.02,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 610.13,
    width: 37.13,
    height: 44.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.320625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 632.17,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.14,
    y: 654.21,
    width: 37.13,
    height: 45.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.062777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.705,
    y: 677.105,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 32.6,
    width: 37.82,
    height: 45.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.521333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.18,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Waynesboro_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: 32.6,
    width: 39.84,
    height: 45.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.845714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.02,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.94,
    y: 32.6,
    width: 40.67,
    height: 45.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3891666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.275,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.61,
    y: 32.6,
    width: 40.95,
    height: 45.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.408823529411765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.085,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.56,
    y: 32.6,
    width: 41.27,
    height: 45.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4276470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.195,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.83,
    y: 32.6,
    width: 41.39,
    height: 45.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.586875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.525,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.22,
    y: 32.6,
    width: 41.46,
    height: 45.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7640000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.95000000000005,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.67,
    y: 32.6,
    width: 41.67,
    height: 45.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2053846153846157
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.505,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.35,
    y: 32.6,
    width: 42.82,
    height: 45.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.76000000000005,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.16,
    y: 32.6,
    width: 43.09,
    height: 45.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5908333333333338
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.70500000000004,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.25,
    y: 32.6,
    width: 44.34,
    height: 45.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1114285714285717
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.42,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.59,
    y: 32.6,
    width: 44.34,
    height: 45.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.608235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.76,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.93,
    y: 32.6,
    width: 44.82,
    height: 45.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.241
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.3399999999999,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.75,
    y: 32.6,
    width: 46.91,
    height: 45.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1054545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.205,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.66,
    y: 32.6,
    width: 48.34,
    height: 45.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3768421052631576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.8299999999999,
    y: 55.18,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 77.76,
    width: 50.21,
    height: 43.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.721875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 99.535,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 121.31,
    width: 50.21,
    height: 44.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1942857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 143.67000000000002,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 166.03,
    width: 50.21,
    height: 44.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4538461538461536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 188.48,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 210.93,
    width: 50.21,
    height: 44.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.749166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 233.425,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 255.92,
    width: 50.21,
    height: 45.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4784615384615383
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 278.53,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 301.13,
    width: 50.21,
    height: 47.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.950625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 324.735,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 348.34,
    width: 50.21,
    height: 47.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 372.03499999999997,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 395.74,
    width: 50.21,
    height: 49.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.116875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 420.675,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 445.61,
    width: 50.21,
    height: 49.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 470.6,
    fontFamily: "Arial"
  }, "\n        Salem_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 495.58,
    width: 50.21,
    height: 50.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.572857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 520.59,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 545.6,
    width: 50.21,
    height: 50.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7894444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 570.815,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 596.03,
    width: 50.21,
    height: 51.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5864285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 621.8149999999999,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.27,
    y: 647.6,
    width: 50.21,
    height: 52.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3473333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.375,
    y: 673.8000000000001,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 77.76,
    width: 49.36,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.525714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.16,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.84,
    y: 77.76,
    width: 50.69,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.224166666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.185,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.53,
    y: 77.76,
    width: 50.73,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3819999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.895,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.26,
    y: 77.76,
    width: 50.91,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3939999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.715,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.17,
    y: 77.76,
    width: 52.48,
    height: 54.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0870588235294116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.41,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.65,
    y: 77.76,
    width: 54.18,
    height: 54.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.73999999999995,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.83,
    y: 77.76,
    width: 54.9,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.28,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.73,
    y: 77.76,
    width: 55.79,
    height: 54.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.916363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.625,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.53,
    y: 77.76,
    width: 56.72,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8628571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.89,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.24,
    y: 77.76,
    width: 56.81,
    height: 54.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.506666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.645,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.05,
    y: 77.76,
    width: 56.95,
    height: 54.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8628571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.525,
    y: 104.80000000000001,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 131.84,
    width: 61.51,
    height: 50.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3573333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 157.02,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 182.2,
    width: 61.51,
    height: 57.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.832
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 210.94,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 239.69,
    width: 61.51,
    height: 61.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.093999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 270.395,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 301.1,
    width: 61.51,
    height: 62.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.591818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 332.435,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 363.77,
    width: 61.51,
    height: 63.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.100666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 395.315,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 426.86,
    width: 61.51,
    height: 65.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 459.415,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 491.96,
    width: 61.51,
    height: 65.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.618235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 524.855,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 557.76,
    width: 61.51,
    height: 68.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.393571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 592.245,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 626.73,
    width: 61.51,
    height: 73.27,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1258333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.235,
    y: 663.365,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 131.84,
    width: 61.61,
    height: 73.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6241176470588234
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.79500000000002,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.59,
    y: 131.84,
    width: 61.79,
    height: 73.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6347058823529412
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.485,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.39,
    y: 131.84,
    width: 62.71,
    height: 73.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.225833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.745,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.1,
    y: 131.84,
    width: 65.09,
    height: 73.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.068125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.64500000000004,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.19,
    y: 131.84,
    width: 67.36,
    height: 73.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.181538461538461
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.87,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.55,
    y: 131.84,
    width: 69.46,
    height: 73.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.961428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.28,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 131.84,
    width: 69.89,
    height: 73.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.992142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 594.945,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.9,
    y: 131.84,
    width: 70.1,
    height: 73.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.689473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.9499999999999,
    y: 168.73000000000002,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 205.62,
    width: 87.83,
    height: 78.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.905,
    y: 244.75,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 283.88,
    width: 87.83,
    height: 88.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.273571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.905,
    y: 328.175,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 372.47,
    width: 87.83,
    height: 103.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.182380952380952
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.905,
    y: 424.29,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 476.1,
    width: 87.83,
    height: 105.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.855333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.905,
    y: 528.96,
    fontFamily: "Arial"
  }, "\n        Chesapeake_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.99,
    y: 581.82,
    width: 87.83,
    height: 118.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.319166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.905,
    y: 640.9100000000001,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 205.62,
    width: 103.96,
    height: 100.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.8,
    y: 255.68,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 363.77,
    y: 205.62,
    width: 104.53,
    height: 100.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.674666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.03499999999997,
    y: 255.68,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.3,
    y: 205.62,
    width: 109.33,
    height: 100.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.674666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.965,
    y: 255.68,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.62,
    y: 205.62,
    width: 122.38,
    height: 100.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.269473684210527
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.81,
    y: 255.68,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 305.74,
    width: 126.41,
    height: 101.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.977647058823529
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.025,
    y: 356.55,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 407.37,
    width: 126.41,
    height: 145.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.653157894736842
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.025,
    y: 479.91,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 552.45,
    width: 126.41,
    height: 147.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.900625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.025,
    y: 626.225,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.23,
    y: 305.74,
    width: 155.29,
    height: 128.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.161428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.875,
    y: 369.87,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.51,
    y: 305.74,
    width: 158.49,
    height: 128.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.688333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.755,
    y: 369.87,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.23,
    y: 434,
    width: 90.21,
    height: 266,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.939230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.33500000000004,
    y: 567,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.44,
    y: 434,
    width: 223.56,
    height: 266,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.968571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.22,
    y: 567,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.9306b18ac61bbde2a13c479a8a0e8897.svg";
export { ForwardRef as ReactComponent };